import React from "react";
import "./i18n";
import AppErrorBoundary from "./components/AppErrorBoundary";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
// A importação do ReactQueryDevtools foi removida para limpar a UI

import AuthProvider from "./contexts/AuthContext";
import { ScreenProvider } from "./contexts/ScreenContext";
import { ThemeProvider } from "./contexts/ThemeContext";

import "leaflet/dist/leaflet.css";
import AppRoutes from "./routes/AppRoutes";
import SessionWarning from "./components/SessionWarning";
import "./index.css";
import "./App.css";

import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const emotionCache = createCache({ key: "mui", prepend: true });

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const App = () => (
  <React.StrictMode>
    <AppErrorBoundary>
    <CacheProvider value={emotionCache}>
      <QueryClientProvider client={queryClient}>
        <Router>
          <AuthProvider>
            <ScreenProvider>
              <ThemeProvider>
                <AppRoutes />
                <SessionWarning />
                <ToastContainer position="top-right" newestOnTop />
              </ThemeProvider>
            </ScreenProvider>
          </AuthProvider>
        </Router>
        {/* O ReactQueryDevtools foi removido daqui para não exibir a janela flutuante */}
      </QueryClientProvider>
    </CacheProvider>
    </AppErrorBoundary>
  </React.StrictMode>
);

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<App />);

// Não instanciar ResizeObserver globalmente: navegadores Android antigos podem
// não o disponibilizar e o React/MUI já gere os observadores necessários.
